"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SkillTimeBar;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _SkillTimeBarModule = _interopRequireDefault(require("./SkillTimeBar.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FILLER_MAX_WIDTH_PX = 145;

function SkillTimeBar(_ref) {
  var _ref$isCatchable = _ref.isCatchable,
      isCatchable = _ref$isCatchable === void 0 ? false : _ref$isCatchable,
      _ref$isCatched = _ref.isCatched,
      isCatched = _ref$isCatched === void 0 ? false : _ref$isCatched,
      _ref$filledPerc = _ref.filledPerc,
      filledPerc = _ref$filledPerc === void 0 ? 0 : _ref$filledPerc,
      _ref$catchBarWidthPer = _ref.catchBarWidthPerc,
      catchBarWidthPerc = _ref$catchBarWidthPer === void 0 ? 50 : _ref$catchBarWidthPer,
      _ref$moveIconPerc = _ref.moveIconPerc,
      moveIconPerc = _ref$moveIconPerc === void 0 ? 0 : _ref$moveIconPerc,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  var fillerStyle = {
    width: isCatchable ? "".concat(FILLER_MAX_WIDTH_PX, "px") : "".concat(FILLER_MAX_WIDTH_PX / 100 * filledPerc, "px")
  };
  var catchFillerStyle = {
    width: "".concat(FILLER_MAX_WIDTH_PX / 100 * catchBarWidthPerc, "px")
  };
  var moveIconStyle = {
    left: "".concat(FILLER_MAX_WIDTH_PX / 100 * moveIconPerc, "px")
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_SkillTimeBarModule.default.bar, isCatchable && _SkillTimeBarModule.default.isCatchable, isCatched && _SkillTimeBarModule.default.isCatched, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SkillTimeBarModule.default.fillerWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_SkillTimeBarModule.default.filler, _SkillTimeBarModule.default.main),
    style: fillerStyle
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_SkillTimeBarModule.default.filler, _SkillTimeBarModule.default.catch),
    style: catchFillerStyle
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _SkillTimeBarModule.default.moveIcon,
    style: moveIconStyle
  })));
}